/* eslint-disable react-hooks/exhaustive-deps */
import { GridCallbackDetails, GridRowParams, MuiEvent } from "@mui/x-data-grid-premium";
import { useEffect } from "react";
import { DataGrid, Dialog, Grid, IGridColDef, IconButton, Stack } from "src/components";
import DialogContent from "src/components/DialogContent";
import DialogTitle from "src/components/DialogTitle";
import { DoorExitIcon } from "src/components/Icons/doorexit";
import { translate } from "src/i18n/tHelper";
import VwOrganizasyonYetkiDTO from "src/models/Base/Yetki/VwOrganizasyonYetkiDTO";
import { useLazyOrganizasyonSecimQuery } from "src/services/Auth/AuthApi";
import { useGetOrganizasyonByKullaniciQuery } from "src/services/OrganizasyonYetki/OrganizasyonApi";
import api from "src/services/core/api";
import { useAppDispatch, useAppSelector } from "src/store";
import AuthSlice from "src/store/Slices/Base/AuthSlice";
import OrganizasyonYetkiSlice from "src/store/Slices/Yetki/OrganizasyonYetkiSlice";
interface OrganizasyonSecimProps {
    menuden?: boolean;
};
const translatePath = "pages|login";
const OrganizasyonSecim = (props: OrganizasyonSecimProps): JSX.Element => {
    const userState = useAppSelector(s => s.userLogin);
    const query = useGetOrganizasyonByKullaniciQuery(userState.userInfo?.id, { skip: !userState.isLoggedIn });
    const organizasyonYetkiState = useAppSelector(s => s.userOrganizasyon);
    const { organizasyon } = useAppSelector(s => s.userOrganizasyon);
    const dispatch = useAppDispatch();

    const [orgSecimQuery, orgSecimQueryState] = useLazyOrganizasyonSecimQuery();

    useEffect(() => {
        if (organizasyon.fkOrganizasyon > 0)
            return;
        if (query.data?.length === 1)
            secHandler(null, query.data[0]);
        else if (query.data?.length > 0)
            dispatch(OrganizasyonYetkiSlice.actions.setOpen(true));
    }, [query.data]);

    const secHandler = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, row: VwOrganizasyonYetkiDTO) => {
        await orgSecimQuery({
            userId: userState.userInfo?.id,
            organizasyonId: row.fkOrganizasyon
        }).unwrap().then((data) => {
            dispatch(OrganizasyonYetkiSlice.actions.setOrganizasyon(row));
            dispatch(OrganizasyonYetkiSlice.actions.setOpen(false));
            dispatch(api.util.resetApiState());
        }).catch(e => e);
    };
    const columns: IGridColDef<VwOrganizasyonYetkiDTO>[] = [
        {
            field: 'organizasyon',
            headerName: translate(translatePath, "Organizasyon"),
            flex: 1
        },
        {
            field: 'action',
            headerName: translate(translatePath, "Seç"),
            headerAlign: 'center',
            align: 'center',
            width: 55,
            renderCell: (params) => {
                return (
                    <Stack direction="row">
                        <IconButton size="small" color='primary' onClick={(e) => { secHandler(e, params.row); }}><DoorExitIcon /></IconButton>
                    </Stack>
                );
            }
        }
    ];
    const onRowDoubleClick = (params: GridRowParams<VwOrganizasyonYetkiDTO>, event: MuiEvent<React.MouseEvent<HTMLElement, MouseEvent>>, details: GridCallbackDetails<any>): void => {
        secHandler(null, params.row);
    };
    const closeHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        if (props.menuden)
            dispatch(OrganizasyonYetkiSlice.actions.setOpen(false));
        else dispatch(AuthSlice.actions.logOut());
    };
    //Terminale Eimza Pin bilgisi gönderilerek Eimza doğrulama gerçekleştiriliyor.
    return (
        <Dialog
            fullWidth
            open={organizasyonYetkiState.open}
            maxWidth="sm"
        >
            <DialogTitle>
                {translate(translatePath, "Bölüm Seçimi")}
                <IconButton
                    customType="close"
                    onClick={closeHandler}
                    sx={{
                        padding: 0,
                        margin: 0,
                        zIndex: 999999999999,
                        display: "block",
                        height: "24px",
                        width: "24px",
                        borderRadius: "25px",
                        textAlign: "center",
                        position: "fixed",
                        top: "5px",
                        right: "5px"
                    }}
                />
            </DialogTitle>
            <DialogContent>
                <Grid container paddingTop={1}>
                    <Grid item md={12}>
                        <DataGrid
                            enableQuickFilter
                            hiddenExport={true}
                            hiddenColumnsButton={true}
                            hiddenFilters={true}
                            sx={{ height: 350 }}
                            pinnedColumns={{ right: ["action"] }}
                            loading={query.isFetching || orgSecimQueryState.isFetching}
                            columns={columns}
                            hideFooter
                            rows={query.data || []}
                            columnHeaderHeight={0}
                            getRowId={r => r.fkOrganizasyon}
                            onRowDoubleClick={onRowDoubleClick}
                            localeText={{
                                noRowsLabel: translate(translatePath, "Bölüm yetkiniz yoktur")
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default OrganizasyonSecim;